import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconChartTracker = () => {
  return (

      <g>
        <path
          d="M.75 0a.75.75 0 0 1 .743.649L1.5.75v13.748h13.752a.75.75 0 0 1 .743.648l.007.102a.75.75 0 0 1-.649.744l-.101.007H1.05a1.05 1.05 0 0 1-1.044-.936L0 14.949V.751A.75.75 0 0 1 .75 0zm15.032 3.64c.266.266.29.683.073.977l-.073.084-5.31 5.316a.75.75 0 0 1-.977.073l-.084-.073-2.963-2.965-2.718 2.72a.75.75 0 0 1-.976.074l-.084-.073a.751.751 0 0 1-.073-.978l.073-.084L5.918 5.46a.75.75 0 0 1 .977-.073l.084.073L9.94 8.425l4.78-4.785a.75.75 0 0 1 1.061 0z"
          
        />
      </g>
  );
};


export default withIcon(IconChartTracker);
